<template>
  <div class="privacy-policy-header-container">
    <div class="privacy-policy-header">
      <div class="privacy-policy-logo-container">
        <img
          class="privacy-policy-header-logo-icon"
          alt=""
          :src="menuInfo.icon"
        />
        <div class="header-text">
          <div class="header-label">{{ menuInfo.label }}</div>
          <div class="header-description">{{ menuInfo.info }}</div>
        </div>
      </div>
      <img
        class="chevron-left-icon"
        alt=""
        src="../../assets/chevronleft.svg"
        @click="goBack"
      />
    </div>
    <!-- <div class="separator-line"></div> -->
    <img
      class="separator-icon"
      loading="lazy"
      alt=""
      src="../../assets/separator.svg"
    />
  </div>
  <div class="privacy-policy-container">
    <div class="privacy-policy-info">
      <div class="message-input-frame">
        <div class="paragraph-container">
          <p>
            Hipster ipsum tattooed brunch I'm baby. Pinterest put freegan 90's
            I'm tonx polaroid. Blog pbr&b ipsum stumptown plaid level yolo
            gochujang +1.
          </p>
          <p>
            Salvia austin brooklyn chambray swag distillery vhs everyday
            sriracha selfies. Twee post-ironic lyft air marfa. Tattooed jomo
            semiotics listicle aesthetic semiotics tonx pin everyday ipsum.
            Bicycle snackwave mukbang bulb fam twee bushwick thundercats
            locavore fund. I'm art af locavore activated.
          </p>
          <p>
            Vinyl lomo mlkshk vegan sold waistcoat forage bushwick diy. Ramps
            brooklyn blue blue intelligentsia sriracha gentrify rights.
            Biodiesel sustainable hipster of yr probably kale. Direct gastropub
            hashtag typewriter street. Drinking waistcoat retro microdosing
            mixtape wolf.
          </p>
          <p>
            Celiac trade vinyl axe shaman schlitz leggings. Kickstarter venmo
            heard crucifix hot cronut echo kinfolk. Kogi +1 sold meh fashion
            beard yr etsy hexagon franzen. Pinterest kale flannel plant shaman
            bird keytar palo. Pok craft meditation hoodie literally echo heard
            affogato. Freegan scenester schlitz umami knausgaard small green
            ipsum. Tofu hell tbh art crucifix.
          </p>
          <p>
            Before succulents hella chillwave typewriter. Try-hard vegan baby
            thundercats bag vibecession copper park. Farm-to-table cloud 90's
            level jomo. Normcore lumbersexual enamel celiac shaman jianbing
            brunch hot. Tousled vice bodega tbh skateboard drinking. Deep pabst
            toast distillery on listicle heard selfies dreamcatcher. Toast
            whatever mi forage fam tbh vice hella. Typewriter tile cold-pressed
            pitchfork flexitarian narwhal polaroid irony ramps.
          </p>
          <p>
            Shoreditch literally shabby polaroid typewriter church-key bodega
            boys. 3-moon 8-bit iceland level vhs slow-carb neutra pitchfork
            knausgaard disrupt. Raw wayfarers aesthetic chillwave kogi
            chartreuse kogi pitchfork juice. Booth squid franzen locavore bun
            pinterest occupy. Franzen mukbang slow-carb shorts bun biodiesel.
            Gatekeep gastropub waistcoat blue mukbang gochujang poutine tonx
            kogi. Yes +1 pour-over retro aesthetic.
          </p>
          <p>
            Praxis diy salvia v meh. Pok it heirloom taiyaki live-edge pabst.
            Butcher kickstarter vape gatekeep adaptogen raw chillwave cray braid
            belly. Stumptown shaman intelligentsia coffee level. Tacos
            dreamcatcher lomo cleanse kickstarter bicycle tousled. Venmo
            coloring hammock drinking bird bird aesthetic ramps axe brooklyn.
            Probably cold-pressed succulents bespoke bodega green yuccie godard.
            Thundercats vinegar distillery drinking locavore. Live-edge hipster
            mi pabst fam axe knausgaard yolo. Cliche bulb church-key bruh dollar
            heirloom. LaCroix bicycle drinking direct godard sriracha godard
            heirloom scenester gatekeep.
          </p>
          <p>
            Boys shoreditch mixtape pork iPhone activated I'm truck gentrify.
            Axe cold-pressed gentrify hexagon baby artisan. Typewriter
            skateboard tattooed chicharrones tote same etsy vegan taxidermy.
            Freegan banjo chicharrones kogi pbr&b.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const hideDetailsEmit = defineEmits(["hide-details"]);

defineProps({
  menuInfo: Object,
});

function goBack() {
  // Emit an event to notify the parent component to show the privacy-policy
  hideDetailsEmit("hide-details");
}
</script>

<style scoped>
.privacy-policy-header-container {
  align-self: stretch;
  background-color: var(--white-default);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--padding-11xl) 0px var(--padding-xl) 0px;
  gap: var(--gap-xl);
}

.privacy-policy-header {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  gap: var(--gap-xl);
  max-width: 112%;
  flex-shrink: 0;
}

.privacy-policy-logo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}

.privacy-policy-header-logo-icon {
  overflow: hidden;
  flex-shrink: 0;
  height: 30px;
  width: 30px;
  position: relative;
  min-height: 30px;
}

.header-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  text-align: left;
  position: relative;
  line-height: 27px; /* if 24px then it will look like sidebar */
  padding: var(--padding-12xs) 0px;
  gap: 5px; /* if remove then it will look like sidebar */

  .header-label {
    color: var(--black-default);
    font-size: 16px;
    letter-spacing: 0.01em;
    font-weight: 600;
    display: inline-block;
  }
  .header-description {
    white-space: nowrap;
    margin-top: -4px;
    font-weight: 400;
    font-size: 15px;
    letter-spacing: 0em;
    color: var(--black-medium);
  }
}

.chevron-left-icon {
  height: 48px;
  width: 48px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0rem -1.1rem 0rem 0rem;
}

.separator-icon {
  /* align-self: stretch;
  width: 94%;
  border: 0.5px solid var(--gray-dark); */
  align-self: stretch;
  /* height: 1px; */
  position: relative;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;
}

.privacy-policy-container {
  height: 100%;
  color: var(--black-default);
  overflow: hidden;
  padding-bottom: 40px;

  .privacy-policy-info {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    font-size: var(--paragraph-primary-regular-regular-size);
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-right: 40px; /* Increase/decrease this value for cross-browser compatibility */
    box-sizing: content-box; /* So the width will be 100% + 45px */
    color: var(--black-default);

    .message-input-frame {
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding: 0px 0px 0px;
      box-sizing: border-box;

      .paragraph-container {
        margin-bottom: -1253px;
        align-self: stretch;
        position: relative;
        line-height: 22px;
        letter-spacing: 0.01em;
        font-size: 16px;
        font-weight: 400;
        color: var(--black-default);

        p {
          margin-bottom: 2rem;
        }
      }
    }
  }
}
</style>
